export const ANALYTICS_EVENTS = {
  SCREEN_VIEW: "screen_view",

  WALK_IN_SERVICE_SELECTED: "walk_in_service_selected",
  WALK_IN_NEXT_PRESSED: "walk_in_next_pressed",
  USER_INFO_NEXT_PRESSED: "user_info_next_pressed",
  USER_INFO_NEW_WALK_IN_SUCCESS: "user_info_new_walkin_success",
} as const;
